module.exports = __webpack_public_path__ + "static/media/scanner-beep-charge.02566351.ogg";